var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.346,
    height: 18,
    viewBox: "0 0 17.346 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_434",
    "data-name": "Union 434",
    d: "M19228.451,15051a2.457,2.457,0,0,1-2.453-2.447v-13.1a2.458,2.458,0,0,1,2.453-2.451h12.443a2.455,2.455,0,0,1,2.449,2.451v13.1a2.453,2.453,0,0,1-2.449,2.447Zm-.828-15.549v13.1a.827.827,0,0,0,.828.822h12.443a.826.826,0,0,0,.826-.822v-13.1a.826.826,0,0,0-.826-.826h-12.443A.827.827,0,0,0,19227.623,15035.449Zm2.949,11.984a.617.617,0,0,1,0-1.233h8.191a.617.617,0,0,1,0,1.233Zm0-3.273a.616.616,0,0,1,0-1.232h5.734a.616.616,0,1,1,0,1.232Zm.254-3.66a.609.609,0,0,1,.133-.669l2.457-2.451a.607.607,0,0,1,.869,0l1.166,1.161,2.021-2.355a.617.617,0,1,1,.941.8l-2.461,2.867a.6.6,0,0,1-.445.209.559.559,0,0,1-.453-.177l-1.205-1.2-2.025,2.021a.608.608,0,0,1-1-.2Z",
    transform: "translate(-19225.998 -15032.998)",
    fill: "#a2a4a6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports_icon.ab2b62a254fdd91aa55a9f70df6f6606.svg";
export { ForwardRef as ReactComponent };